export const NO_CARD = 255;
/** Regular (not `const`) enum: `const enum` cannot cross package boundaries under `isolatedModules`. */
export var Suit;
(function (Suit) {
    Suit[Suit["Clubs"] = 0] = "Clubs";
    Suit[Suit["Diamonds"] = 1] = "Diamonds";
    Suit[Suit["Hearts"] = 2] = "Hearts";
    Suit[Suit["Spades"] = 3] = "Spades";
    Suit[Suit["Joker"] = 4] = "Joker";
})(Suit || (Suit = {}));
export const LITTLE_JOKER = 52;
export const BIG_JOKER = 53;
/** Ranks: 2..10 numeric, J=11, Q=12, K=13, A=14; jokers report LJ=15, BJ=16. */
export const RANK_JACK = 11;
export const RANK_QUEEN = 12;
export const RANK_KING = 13;
export const RANK_ACE = 14;
export const RANK_LITTLE_JOKER = 15;
export const RANK_BIG_JOKER = 16;
export const STANDARD_SUITS = [Suit.Clubs, Suit.Diamonds, Suit.Hearts, Suit.Spades];
export const cardOf = (suit, rank) => suit * 13 + (rank - 2);
export const rankOf = (c) => (c >= 52 ? 15 + (c - 52) : (c % 13) + 2);
export const suitOf = (c) => (c >= 52 ? Suit.Joker : Math.floor(c / 13));
export const isJoker = (c) => c === LITTLE_JOKER || c === BIG_JOKER;
export const isCard = (c) => typeof c === 'number' && Number.isInteger(c) && c >= 0 && c <= 53;
/** All 54 card ids in encoding order: C2..CA, D2..DA, H2..HA, S2..SA, LJ, BJ. */
export const ALL_CARDS = Object.freeze(Array.from({ length: 54 }, (_, i) => i));
const RANK_CHARS = '23456789TJQKA';
const SUIT_CHARS = 'CDHS';
/** "AS", "2D", "TC", "LJ", "BJ". */
export function str(c) {
    if (c === LITTLE_JOKER)
        return 'LJ';
    if (c === BIG_JOKER)
        return 'BJ';
    if (c === NO_CARD)
        return '--';
    if (!isCard(c))
        throw new RangeError(`Invalid CardId ${c}`);
    return `${RANK_CHARS[c % 13]}${SUIT_CHARS[Math.floor(c / 13)]}`;
}
/** Inverse of `str`. Accepts "10" as an alias for "T" and lowercase input. */
export function parse(s) {
    const u = s.trim().toUpperCase();
    if (u === 'LJ')
        return LITTLE_JOKER;
    if (u === 'BJ')
        return BIG_JOKER;
    if (u === '--')
        return NO_CARD;
    const m = /^(10|[2-9TJQKA])([CDHS])$/.exec(u);
    if (!m)
        throw new RangeError(`Invalid card string "${s}"`);
    const rankChar = m[1] === '10' ? 'T' : m[1];
    const rank = RANK_CHARS.indexOf(rankChar) + 2;
    const suit = SUIT_CHARS.indexOf(m[2]);
    return cardOf(suit, rank);
}
/** Parse a space-separated hand string, e.g. "AS KS 2D BJ". */
export const parseHand = (s) => s
    .split(/\s+/)
    .filter((t) => t.length > 0)
    .map(parse);
export const strHand = (hand) => hand.map(str).join(' ');
//# sourceMappingURL=cards.js.map